import { render, staticRenderFns } from "./TopicStaticPage.vue?vue&type=template&id=94a0032a"
import script from "./TopicStaticPage.vue?vue&type=script&lang=js"
export * from "./TopicStaticPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports